import { atom } from 'jotai';
import { SearchSugItem } from 'shared/models';

export const $SearchSugData = atom<SearchSugItem[]>([]);
$SearchSugData.debugLabel = '$SearchSugData';
